import { CoinsIcon, KeyIcon } from '@gemini/icons';
export const transactionTypeData = [
    {
        label: 'Sale',
        icon: CoinsIcon,
        value: 'BUY',
    },
    {
        value: 'RENT',
        icon: KeyIcon,
        label: 'Rent',
    },
];
